import 'reflect-metadata';
import { asEntity } from '../../SmartDB/Commons/Decorators/Decorator.asEntity';
import { Convertible } from '../../SmartDB/Commons/Decorators/Decorator.Convertible';
import { FundEntity } from './Fund.Entity';
import { BaseEntity } from './index.exports';

@asEntity()
export class HistoryDelegationUser extends BaseEntity {
    protected static _apiRoute: string = 'history-delegations-user';
    protected static _className: string = 'History Delegation by User';

    // #region fields

    @Convertible({ type: String, propertyToFill: 'fund', relation: 'ManyToOne', typeRelation: FundEntity, cascadeSave: true, cascadeLoad: false })
    fund_id!: string;
    fund!: FundEntity | undefined;

    @Convertible({})
    date!: Date;

    @Convertible({})
    user!: string;

    @Convertible({})
    newDelegationsUser!: bigint;

    @Convertible({})
    totalDelegationsUser!: bigint;

    @Convertible({})
    totalDelegationsAll!: bigint;

    @Convertible({})
    newAvailableCommissionsUser!: bigint;

    @Convertible({})
    totalAvailableCommissionsUser!: bigint;

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;

    // #endregion fields

    // #region  db

    public static defaultFieldsWhenUndefined: Record<string, boolean> = {};

    public static alwaysFieldsForSelect: Record<string, boolean> = {
        ...super.alwaysFieldsForSelect,
        fund_id: true,
        date: true,
        user: true,
        newDelegationsUser: true,
        totalDelegationsUser: true,
        totalDelegationsAll: true,
        newAvailableCommissionsUser: true,
        totalAvailableCommissionsUser: true,
    };

    // #endregion  db

    // #region class methods

    public show(): string {
        return `[${this.date} - ${this.fund_id}] user: ${this.user} - delegations: ${this.newDelegationsUser} - totalDelegations: ${this.totalDelegationsUser}}`;
    }

    // #endregion class methods
}
